import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import admindata from '../../components/admindata'
import Loader from 'react-js-loader'
import loader from '../loder.gif'
import { apiRequest } from '../../apiServices/allApi'

const $ = require('jquery')
$.Datatable = require('datatables.net')
export default function Allusers () {
  const [loading, setLoading] = useState(false)

  const id = localStorage.getItem('id')

  //use for pagination..
  let [limit, setLimit] = useState(20)
  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)
  const [findByuserStatus, setFindByuserStatus] = useState('')

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value
    setSearchList(key)
  }

  //   search by status handler
  const searchByStatus = event => {
    setSearchType('0')
    let key = event.target.value
    setFindByStatus(key)
    setFindByuserStatus(key)
  }

  const [user, setUser] = useState(false)
  

  const getUser = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
  try {
    const res = await apiRequest(`admin/today_User/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&_Userstatus=${findByuserStatus} `,"GET",null,headers)
    setLoading(false)
        setUser(res.data.admin)
        setNumberOfPages(res.data.totalPages)
  } catch (error) {
    setLoading(false)
  } finally {
    // setLoading(false)
  }
}


const RedZone = async (id,checked) => {
      const access_token = localStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
     const { value: manualPaymentInput } = await Swal.fire({
            title: 'Enter RedZone Reason',
            input: 'text',
            inputPlaceholder: 'Enter Reason',
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return 'Reason cannot be empty!';
              }
              return null; // Valid input
            },
          });
          if (manualPaymentInput) {
      try {
        const res = await apiRequest(`user/redzone/${id}/${checked}/${manualPaymentInput}`, "GET", null, headers)
        if (res) {
          getUser(); // Refresh user data
        }
      } catch (e) {
        console.error('Error:', e);
      }
      finally {
      }
    }
    };
    const RedZoneLimit = (id, zone) => {
      if (zone == true) {
        RedZone(id, "false")
      } else {
        RedZone(id, "true")

      }
      
    };


  const  blockPlayer= async player=>{
    const userType = player.user_type == 'Block' ? 'User' : 'Block'
    var text1
    // alert(userType)
    if (userType == 'Block') {
      var { value: text1 } = await Swal.fire({
        input: 'textarea',
        inputLabel: 'Block Reason',
        inputPlaceholder: 'Type your reason here...',
        inputAttributes: {
          'aria-label': 'Type your reason here'
        },
        showCancelButton: true
      })
    } else {
      text1 = 'unblock'
    }
    if (text1) {
      // if (confirmBox === true) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
    const res = await apiRequest(  `admin/block_user_api/${player._id}`,"POST",
          { user_type: userType, reason: text1 },headers);
          getUser(res)
          console.log(res)
   
   }else{
    Swal.fire({
      position: 'top-end',
      icon: 'warning',
      title: 'Enter Reason',
      showConfirmButton: false,
      timer: 1500
    })
   }
  
  }


   useEffect(() => {
        getUser(new Date(new Date().setHours(0,0,0,0)), new Date())
    }, [pageNumber, limit, searchList, searchType,findByStatus,findByuserStatus])


  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    user && (
      <div>
        <div className='row mt-5'>
          <div className='col-12 grid-margin'>
            <div className='card text-white'>
              <div className='card-body text-light table_bg'>
                <h4 className='dashboard_heading'>Today User List</h4>

                {/* searching */}
                

                <div className='table-responsive'>
                  <table className='table text-light'>
                    <thead>
                      <tr>
                        <th>#</th>
                        {
                          id =="67f8f9731bb8e80965dd62b8" ?
                          <th> ID</th> : ""
                        }
                        <th> Name</th>
                        <th> Mobile </th>
                        <th> Balance </th>
                        <th> MissMatch</th>
                        <th>Game hold</th>
                        <th> Reffered By </th>
                        <th> Verified </th>
                        <th> Action </th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.map((user, key) => (
                       <tr key={user._id}  style={{ backgroundColor: user.Red_zone ? "red" : "transparent" }}>
                          <td>{key + 1}</td>
                           {
                          id =="67f8f9731bb8e80965dd62b8" ?
                            <td>{user._id}</td>: ""
                        }
                        
                          <td>
                            <span className='pl-2 text-primary'>
                              {user.Name}
                            </span>
                          </td>
                          {admindata?.user?.usertype == 'Admin' ||
                          admindata?.user?.updateLegalData === true ? (
                            <td className='text-success'>
                                <a
      href={`https://wa.me/91${user.Phone}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
                              {user.Phone}
                              </a>
                              </td>
                          ) : (
                            <td className='text-success'>{`${
                              '********' + user.Phone.toString().slice(-2)
                            }`}</td>
                          )}
                          <td>₹{user.Wallet_balance}</td>

                          <td
                            className={`${
                              user.Wallet_balance -
                                (user.wonAmount +
                                  user.totalDeposit +
                                  user.referral_earning +
                                  user.totalBonus -
                                  (user.loseAmount +
                                    user.totalWithdrawl +
                                    user.referral_wallet +
                                    user.withdraw_holdbalance +
                                    user.hold_balance +
                                    user.totalPenalty)) !=
                              0
                                ? 'text-danger'
                                : 'text-success'
                            }`}
                          >
                            ₹{' '}
                            {user.Wallet_balance -
                              (user.wonAmount +
                                user.totalDeposit +
                                user.referral_earning +
                                user.totalBonus -
                                (user.loseAmount +
                                  user.totalWithdrawl +
                                  user.referral_wallet +
                                  user.withdraw_holdbalance +
                                  user.hold_balance +
                                  user.totalPenalty))}
                          </td>
                          <td>{user.hold_balance}</td>
                          <td className='text-success'>{user.referral}</td>
                          <td>
                            <div className='badge badge-outline-success'>
                              {user.verified}
                            </div>
                          </td>
                          <td>
                            <button
                              type='button'
                              className={`btn  mx-1 ${
                                user.user_type == 'Block'
                                  ? 'btn-success'
                                  : 'btn-danger'
                              }`}
                              onClick={() => {
                                blockPlayer(user)
                              }}
                            >
                              {user.user_type == 'Block' ? 'Unblock' : 'Block'}
                            </button>
                              <button
                              type='button'
                              className={`btn  mx-1 ${
                                user.Red_zone == true
                                  ? 'btn-success'
                                  : 'btn-danger'
                              }`}
                              onClick={() => {
                                RedZoneLimit(user._id, user.Red_zone)
                              }}
                            >
                              RedZone
                            </button>
                            <Link
                              type='button'
                              className='btn btn-info mx-1'
                              to={`/user/adduser/${user._id}`}
                            >
                              Edit User
                            </Link>
                            <Link
                              type='button'
                              className='btn btn-primary mx-1'
                              to={`/user/view_user/${user._id}`}
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className='mt-4'>
                  <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageCount={numberOfPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination justify-content-center'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}
